// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.client.syndicationstatus.RentalManagerUserPropertyDetailsSyndicationOverviewStatus

export enum RentalManagerUserPropertyDetailsSyndicationOverviewStatus {
  DECLINED = 'DECLINED',
  INACTIVE = 'INACTIVE',
  PARTIALLY_PUBLISHED = 'PARTIALLY_PUBLISHED',
  PUBLISHED = 'PUBLISHED',
  PUBLISHING = 'PUBLISHING',
  WAITLISTED = 'WAITLISTED',
}

export const RentalManagerUserPropertyDetailsSyndicationOverviewStatus_values = [
  RentalManagerUserPropertyDetailsSyndicationOverviewStatus.DECLINED,
  RentalManagerUserPropertyDetailsSyndicationOverviewStatus.INACTIVE,
  RentalManagerUserPropertyDetailsSyndicationOverviewStatus.PARTIALLY_PUBLISHED,
  RentalManagerUserPropertyDetailsSyndicationOverviewStatus.PUBLISHED,
  RentalManagerUserPropertyDetailsSyndicationOverviewStatus.PUBLISHING,
  RentalManagerUserPropertyDetailsSyndicationOverviewStatus.WAITLISTED,
] as const;
